import React from "react";
import Layout from "../../components/Layout";

const PaymentSuccessPage = () => {
  return (
    <Layout>
      <div className="min-h-screen bg-surface-50 flex items-center justify-center px-6 pt-20">
        <div className="max-w-md w-full text-center">
          {/* Icon */}
          <div className="mx-auto mb-8 w-24 h-24 rounded-full bg-gradient-to-br from-emerald-400 to-emerald-600 flex items-center justify-center shadow-xl shadow-emerald-500/25">
            <svg className="w-12 h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
            </svg>
          </div>

          <h1 className="text-3xl font-extrabold text-surface-900 mb-3">Ödəniş uğurla tamamlandı!</h1>
          <p className="text-surface-500 leading-relaxed mb-8">
            Biletiniz e-mail ünvanınıza göndərildi. Zəhmət olmasa <strong className="text-surface-700">inbox</strong> və <strong className="text-surface-700">spam</strong> qovluğunuzu yoxlayın.
          </p>

          {/* Support info */}
          <div className="bg-white rounded-2xl border border-surface-100 p-5 mb-8">
            <p className="text-sm text-surface-500">
              Bilet çatmayıbsa, əlaqə saxlayın:
            </p>
            <a href="tel:+994556611161" className="text-lg font-bold text-surface-900 hover:text-accent-600 transition">
              +994 55 661 11 61
            </a>
          </div>

          <a
            href="/"
            className="inline-flex items-center gap-2 bg-surface-900 text-white font-semibold px-8 py-4 rounded-2xl hover:bg-surface-800 transition-colors"
          >
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
            </svg>
            Ana səhifəyə qayıt
          </a>
        </div>
      </div>
    </Layout>
  );
};

export default PaymentSuccessPage;
